import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/** Standalone-site search route: wraps <ee-help-search>, feeding the ?q= param and routing on select. */
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  standalone: false,
})
export class SearchComponent implements OnInit {
  query = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.query = params.get('q') ?? '';
    });
  }

  openArticle(slug: string): void {
    this.router.navigate(['/article', slug]);
  }
}
